// src/components/reusable/SearchInputStyles.js

const searchInputStyles = {
  root: {
    height: '48px',
    width: '23%',
    '& .MuiOutlinedInput-root': {
      height: '48px',
      borderRadius: 0,
      backgroundColor: '#fff',
      paddingRight: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px',
      fontSize: '0.95rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#A8A8A8',
    },
    '& .MuiInputAdornment-root': {
      height: '100%',
    },
    '& .MuiIconButton-root': {
      padding: '10px',
    },
  },
};

export default searchInputStyles;
